import { render, staticRenderFns } from "./revision-bar.vue?vue&type=template&id=9151651e&"
import script from "./revision-bar.vue?vue&type=script&lang=js&"
export * from "./revision-bar.vue?vue&type=script&lang=js&"
import style0 from "./revision-bar.vue?vue&type=style&index=0&id=9151651e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports